import React from 'react'
import styled from 'styled-components'
import INFTCategoryButton from './INFTCategoryButton'

const NFTButtonITem = styled.div`
  display: flex;
  justify-content: center;
  margin-right: 1rem;
  padding: 0.5rem;
  background: ${({ theme }) => theme.bg6};
  color: #fff;
  margin-bottom: 1rem;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  user-select: none;
  width: fit-content;

  :hover {
    background: ${({ theme }) => theme.bg7};
  }

  &.active {
    background: ${({ theme }) => theme.bg7};
  }
`

export default function NFTCategoryButton({ text, onClick, active }: INFTCategoryButton) {
  return (
    <NFTButtonITem className={active ? 'active' : ''} onClick={onClick}>
      {text}
    </NFTButtonITem>
  )
}
